module.exports = __webpack_public_path__ + "static/media/1.57622400.jpg";